import {
  FETCH_PROJECT_HEATPROFILE_LIST,
  FETCH_PROJECT_HEATPROFILE_LIST_SUCCESS,
  FETCH_PROJECT_HEATPROFILE_LIST_FAILURE,
  ADD_PROJECT_HEATPROFILE_DETAILS,
  ADD_PROJECT_HEATPROFILE_DETAILS_SUCCESS,
  ADD_PROJECT_HEATPROFILE_DETAILS_FAILURE,
  UPDATE_PROJECT_HEATPROFILE_DETAILS,
  UPDATE_PROJECT_HEATPROFILE_DETAILS_SUCCESS,
  UPDATE_PROJECT_HEATPROFILE_DETAILS_FAILURE,
  DELETE_PROJECT_HEATPROFILE_DETAILS,
  DELETE_PROJECT_HEATPROFILE_DETAILS_SUCCESS,
  DELETE_PROJECT_HEATPROFILE_DETAILS_FAILURE,
} from './types';

//fetch
const fetchProjectHeatProfileList = (payload) => ({
  type: FETCH_PROJECT_HEATPROFILE_LIST,
  ...payload,
});

const fetchProjectHeatProfileListSuccess = (payload) => ({
  type: FETCH_PROJECT_HEATPROFILE_LIST_SUCCESS,
  ...payload,
});

const fetchProjectHeatProfileListFailure = () => ({
  type: FETCH_PROJECT_HEATPROFILE_LIST_FAILURE,
});

//add
const addProjectHeatProfileDetails = (payload) => ({
  type: ADD_PROJECT_HEATPROFILE_DETAILS,
  payload,
});

const addProjectHeatProfileDetailsSuccess = (payload) => ({
  type: ADD_PROJECT_HEATPROFILE_DETAILS_SUCCESS,
  ...payload,
});

const addProjectHeatProfileDetailsFailure = () => ({
  type: ADD_PROJECT_HEATPROFILE_DETAILS_FAILURE,
});

//update
const updateProjectHeatProfileDetails = (payload) => ({
  type: UPDATE_PROJECT_HEATPROFILE_DETAILS,
  ...payload,
});

const updateProjectHeatProfileDetailsSuccess = (payload) => ({
  type: UPDATE_PROJECT_HEATPROFILE_DETAILS_SUCCESS,
  ...payload,
});

const updateProjectHeatProfileDetailsFailure = (payload) => ({
  type: UPDATE_PROJECT_HEATPROFILE_DETAILS_FAILURE,
  ...payload,
});

//delete
const deleteProjectHeatProfileDetails = (payload) => ({
  type: DELETE_PROJECT_HEATPROFILE_DETAILS,
  ...payload,
});

const deleteProjectHeatProfileDetailsSuccess = (payload) => ({
  type: DELETE_PROJECT_HEATPROFILE_DETAILS_SUCCESS,
  ...payload,
});

const deleteProjectHeatProfileDetailsFailure = (payload) => ({
  type: DELETE_PROJECT_HEATPROFILE_DETAILS_FAILURE,
  ...payload,
});

export {
  fetchProjectHeatProfileList,
  fetchProjectHeatProfileListSuccess,
  fetchProjectHeatProfileListFailure,
  addProjectHeatProfileDetails,
  addProjectHeatProfileDetailsSuccess,
  addProjectHeatProfileDetailsFailure,
  updateProjectHeatProfileDetails,
  updateProjectHeatProfileDetailsSuccess,
  updateProjectHeatProfileDetailsFailure,
  deleteProjectHeatProfileDetails,
  deleteProjectHeatProfileDetailsSuccess,
  deleteProjectHeatProfileDetailsFailure,
};
